import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-empty'
})
class EdEmpty extends Vue {

  @Prop() icon: string;

  /* Options: left, right or center, center is default */
  @Prop() align: string;

  get textCss() {
    let align = this.align ? `bsx-text-${this.align}` : 'bsx-text-center';
    return {'bsx-mt-2': this.icon, [align]: true }
  }
}

export default Vue.component('ed-empty', EdEmpty);